















































































import { Component, Prop, Vue } from 'vue-property-decorator';

import { perRoadStore } from '@/store/store';
import { states } from '@/lib/data/states';
import { UnitSystem } from '@/interfaces/units';
import {
  ILayerPerformanceCriteriaImperial,
  ILayerPerformanceCriteriaMetric,
  LayerPerformanceCriteriaType,
  PerRoadLayerType,
} from '@/modules/perRoad/interfaces/perRoad';
import SurfaceDeflection from '@/modules/perRoad/views/components/criteria/SurfaceDeflection.vue';
import HorizontalStrainDistribution
  from '@/modules/perRoad/views/components/criteria/HorizontalStrainDistribution.vue';
import ConventionalMeDesignHorizontal
  from '@/modules/perRoad/views/components/criteria/ConventionalMeDesignHorizontal.vue';
import ConventionalMeDesignVertical
  from '@/modules/perRoad/views/components/criteria/ConventionalMeDesignVertical.vue';
import { createPerRoadValidations } from '@/modules/perRoad/lib/validations';
import {
  createAcHorizontalDistributionPerformanceCriteria,
  createHorizontalMeDesignCriteria,
  createVerticalMeDesignCriteria
} from "@/modules/perRoad/lib/layers/performanceCriteria";

Component.registerHooks(['validations']);

@Component({
  components: {
    ConventionalMeDesignHorizontal,
    ConventionalMeDesignVertical,
    HorizontalStrainDistribution,
    SurfaceDeflection,
  },
})
export default class PerRoadLayerPerformance extends Vue {
  @Prop() readonly id!: string;

  @Prop() readonly page!: number;

  stateOptions = states;

  layerTypes = PerRoadLayerType;

  performanceCriteria = LayerPerformanceCriteriaType;

  get scenario() {
    return perRoadStore.currentScenario;
  }

  get scenarioImperial() {
    return perRoadStore.currentImperial;
  }

  get isImperial() {
    return this.scenario.unitSystem === UnitSystem.Imperial;
  }

  addStrainDistribution(n: number) {
    this.scenarioImperial.layers[n].performanceCriteria.push(createAcHorizontalDistributionPerformanceCriteria());
  }

  addTraditionalHorizontal(n: number) {
    this.scenarioImperial.layers[n].performanceCriteria.push(createHorizontalMeDesignCriteria());
  }

  addTraditionalVertical(n: number) {
    this.scenarioImperial.layers[n].performanceCriteria.push(createVerticalMeDesignCriteria());
  }

  removeCriteria(layerNum: number,
                 criteria: ILayerPerformanceCriteriaImperial | ILayerPerformanceCriteriaMetric) {
    console.log(layerNum, criteria);
    // @ts-ignore
    this.scenario.layers[layerNum].performanceCriteria = this.scenario.layers[layerNum].performanceCriteria.filter((C) => C !== criteria);
    this.sync();
  }

  sync() {
    perRoadStore.setCurrentScenario(this.scenario);
  }

  save() {
    this.sync();
    perRoadStore.saveCurrentScenario();
  }

  validations() {
    return createPerRoadValidations(this.scenarioImperial, this.page);
  }
}

